module.exports = __webpack_public_path__ + "static/media/linkedin.eef55367.svg";